import { Typography } from '@mui/material'
import { SetButton } from './Atom'
import { useSelector } from 'react-redux'
import { setProvidersMetricTabs, setProvidersTableData, setSelectedProvidersMetricTab } from '../../../redux/slices/providersSlice'
import { useDispatch } from 'react-redux'

type Props = {}

const ApplyButton = (props: any) => {

    const dispatch = useDispatch();

    const { fetchProviderData, type } = props

    const allProviderColumns = useSelector((state: any) => {
        return state.providers.allProviderColumns
    })

    const allProviderMetrics = useSelector((state: any) => {
        return state.providers.allProviderMetrics
    })

    const selectedProviderMetrics = useSelector((state: any) => {
        return state.providers.selectedProviderMetrics
    })

    const selectedProviders = useSelector((state: any) => {
        return state.providers.selectedProviders
    })

    const isDisabled = type == "columns" ? !allProviderColumns?.length : !(selectedProviders?.length && selectedProviderMetrics?.length);

    const handleClickApply = async () => {

        dispatch(setProvidersTableData([]));
        dispatch(setSelectedProvidersMetricTab({}));


        if (selectedProviderMetrics?.length) {
            dispatch(setProvidersMetricTabs([...selectedProviderMetrics]));
        } else {
            dispatch(setProvidersMetricTabs([]));
        }


        // await fetchProviderData();
    }

    return (
        <SetButton
            disabled={isDisabled}
            onClick={() => handleClickApply()}
        >
            <Typography color={isDisabled ? "#c4c4c4" : "#FFFFFF"} fontSize={14} fontWeight={500}>
                Apply
            </Typography>
        </SetButton>
    )
}

export default ApplyButton